import * as React from 'react';
import { SystemGrid, SystemPanel, SystemPopup } from '..';
import { debug } from 'console';
import { ISystemPanelProps } from '../dashboard/SystemPanel';
import { hasReadPermission } from '../../service/userService';
import ArchiveForm from './archive/ArchiveAuditForm';

export type ISystemGridFormState = {
    isFormVisible: boolean;
    PrimaryKeyEncrypted?: string;
    refreshCounter: number;
    data?: any
    showRefresh?: boolean
    isArchiveFormVisible: boolean
};

type ITriggerAction = "OPEN" | "CLOSE" | "REFRESH" | "NONE"

export interface ISystemGridProps {

    label: string;
    form?: React.ComponentType<any>;
    grid?: React.ComponentType<any>; //typeof SystemGrid | JSX.Element | null; //
    data?: any;
    onRowClick?(event: any): boolean;
    onRowDoubleClick?(event: any): void;
    onRecordUpdated?(response: any): void;
    onAdd?(): void;
    onRefresh?(): void;
    onSave?(): void;
    onSaveAndClose?(): void;
    /** Shows the form with initial data and refreshes the grid on save, 
     * raises onShowAddComplete after performing the operating. 
     * if you pass on PrimaryKeyEncryptedEncrypted it will be in edit mode or else add mode */
    showAdd?: any;
    onShowAddComplete?(): void;
    showBanner?: boolean;
    triggerAction?: ITriggerAction
    onAddCaller?(caller?: any): void
    showBoth?: boolean
    alwaysInAdd?: boolean
    disabled?: boolean
    securityObject?: string
    refresh?: string;
    showRefresh?: boolean
    /** table to be reviewed */
    table?: string
    /** schema to be reviewed */
    schema?: string,
    primaryKeyEncrypted?: string | number
}

export class SystemGridAndForm extends React.Component<ISystemGridProps & ISystemPanelProps, ISystemGridFormState, any> {

    showForm = () => this.setState({ isFormVisible: true });
    closeForm = () => this.setState({ isFormVisible: false });
    refresh = () => this.setState({ refreshCounter: this.state.refreshCounter + 1 });

    constructor(props: any) {
        super(props)
        this.state = {
            isFormVisible: false,
            refreshCounter: 0,
            showRefresh: this.props.showRefresh === false ? false : true,
            data: { ...props.data }
        }
        this.props.onAddCaller && this.props.onAddCaller(this.onAdd);
    }

    componentDidMount = () => {
        this.setState({ data: { ...this.props.data } });
    }

    componentDidUpdate = (prevProps: ISystemGridProps) => {
        if (prevProps.data != this.props.data)
            this.setState({ data: { ...this.props.data } });

        if (prevProps.showAdd != this.props.showAdd) {
            this.onAdd(this.props.showAdd);
        }

        if (prevProps.refresh != this.props.refresh)
            this.refresh();

        if (prevProps.triggerAction != this.props.triggerAction)
            this.triggerAction();
    }

    triggerAction = () => {
        switch (this.props.triggerAction) {
            case "OPEN":
                this.onAdd(); break;
            case "CLOSE":
                this.closeForm(); break;
            case "REFRESH":
                this.refresh(); break;
        }
    }

    onRowDoubleClick = (event: any) => {
        if (this.props.onRowDoubleClick) this.props.onRowDoubleClick(event)
    }

    onRowClick = (event: any) => {
        if (this.props.onRowClick) {
            if (this.props.onRowClick(event))
                this.setState({ data: event.dataItem }, () => this.showForm())
        }
        else this.setState({ data: event.dataItem }, () => this.showForm())
    };

    onAdd = (initialData: any = undefined) => {
        if (this.props.onAdd) this.props.onAdd();
        else this.setState({ data: this.props.data }, () => this.showForm());
    };

    onRecordUpdated = (response: any) => {
        if (this.props.onRecordUpdated) this.props.onRecordUpdated(response);
        if (this.props.showAdd && this.props.onShowAddComplete) this.props.onShowAddComplete()
        this.closeForm();
        this.refresh();
    };

    onSaveAndClose(response: any) {
        if (this.props.onSaveAndClose) this.props.onSaveAndClose()
        else {
            this.closeForm();
        }
    }

    handleReviewClose = () => this.setState({ isArchiveFormVisible: false })
    handleReviewButton = () => this.setState({ isArchiveFormVisible: true })

    render = (): JSX.Element => {
        let Form = this.props.form || null;
        let Grid = this.props.grid || null;
        let showGrid = hasReadPermission(this.props.securityObject);
        let showAdd = this.props.showAdd != undefined ? this.props.showAdd : true
        return <>
            <fieldset disabled={this.props.disabled} className="fieldsetGridAndForm">
                {
                    Form && !this.props.showFormAbove && this.state.isFormVisible &&
                    <SystemPopup visible={this.state.isFormVisible} onClose={this.closeForm} showBanner={this.props.showBanner}>
                        <Form data={this.state.data} onRecordUpdated={this.onRecordUpdated} onClose={this.closeForm} />
                    </SystemPopup>
                }

                {
                    <ArchiveForm visible={this.state.isArchiveFormVisible} onClose={this.handleReviewClose}
                        table={this.props.table as string} schema={this.props.schema as string} primaryKeyEncrypted={this.props.primaryKeyEncrypted} />
                }

                <SystemPanel AddButtonDisable={this.props.AddButtonDisable} showRefresh={this.state.showRefresh} securityObject={this.props.securityObject} label={this.props.label} toolbar={this.props.toolbar}
                    onAdd={this.onAdd} onRefresh={this.refresh} showAddbuttonOnForm={this.props.showAddbuttonOnForm != undefined ? this.props.showAddbuttonOnForm : true} showAdd={this.props.showAdd != undefined ? this.props.showAdd : true}
                    collapse={this.props.collapse} showArchive={this.props.showArchive} onArchive={this.handleReviewButton}>

                    {
                        Form && this.props.showFormAbove &&
                        <>
                            <Form data={this.state.data} onRecordUpdated={this.onRecordUpdated} onClose={this.closeForm} alwaysInAdd={this.props.alwaysInAdd} />
                            <hr className='form-grid-separator' />
                        </>
                    }

                    {showGrid ? <Grid refresh={this.state.refreshCounter} onRowClick={this.onRowClick} onRowDoubleClick={this.onRowDoubleClick} data={this.props.data} />
                        : <div>You dont have permission to read this object</div>}
                </SystemPanel>
            </fieldset>
        </>;
    }
}

export abstract class SystemGridForm<P> extends React.Component<P, ISystemGridFormState> {
    state = {
        isFormVisible: false,
        refreshCounter: 0,
        PrimaryKeyEncrypted: ''
    };

    constructor(props: P) {
        super(props);
    }

    componentDidMount() {
    }

    showForm = () => this.setState({ isFormVisible: true });
    closeForm = () => this.setState({ isFormVisible: false });
    refresh = () => this.setState({ refreshCounter: this.state.refreshCounter + 1 });
    setPrimaryKeyEncrypted = (key: string) => this.setState({ PrimaryKeyEncrypted: key });


    onListRowClick = (data: any) => {
        this.setPrimaryKeyEncrypted(data.PrimaryKeyEncrypted);
        this.showForm();
    };

    onAdd = () => {
        this.setPrimaryKeyEncrypted('');
        this.showForm();
    };

    onUpdate = (response: any) => {
        this.closeForm();
        this.refresh();
    };

    onClose = () => {
        this.closeForm();
    }

    onSaveAndClose(response: any) {

    }

    abstract render(): JSX.Element;
}

